import { useToast } from '@/context/ToastContext';
import styles from './Toast.module.css';

export function Toast() {
  const { toast } = useToast();

  // role="status" announces cart additions to screen readers without stealing focus.
  return (
    <div role="status" aria-live="polite">
      {toast && <div className={styles.toast}>{toast}</div>}
    </div>
  );
}
